import * as React from 'react';
import { createStaticLayout, createResponsiveLayout, createResponsiveLayoutTemplate, } from './PageStripLayout';
import { st, classes } from '../Pagination.st.css';
import { DataHooks, HelperIds } from '../constants';
export class PageStrip extends React.Component {
    constructor() {
        super(...arguments);
        this.responsiveLayoutIsFresh = false;
        this.state = { responsiveLayout: null };
    }
    componentDidMount() {
        this.updateLayoutIfNeeded();
    }
    UNSAFE_componentWillReceiveProps() {
        this.responsiveLayoutIsFresh = false;
    }
    componentDidUpdate() {
        this.forceRepaintInMsEdge();
        if (this.isResponsive()) {
            this.updateLayoutIfNeeded();
        }
    }
    render() {
        return (React.createElement("div", { ref: (el) => (this.rootNode = el), "data-hook": DataHooks.pageStrip, id: this.props.id ? this.props.id + HelperIds.pageStrip : null, className: st(classes.pageStrip, this.props.className), "data-aid": "qa-page-strip" },
            React.createElement("div", { "data-hook": DataHooks.pageStripRenderContainer, className: classes.pageStripInner }, this.renderLayout(this.getLayout(), false)),
            this.isResponsive() && (React.createElement("div", { className: classes.pageStripInner + ' ' + classes.pageStripTemplate }, this.renderLayout(createResponsiveLayoutTemplate(this.props), true)))));
    }
    forceRepaintInMsEdge() {
        // MS Edge has a glitch that makes page numbers invisible when switching to the preview
        // mode in Santa editor. As a workaround we need to force text re-rendering.
        // Changing font-variant to small-caps should do the trick without actually affecting
        // the appearance of digits.
        const inlineStyle = this.rootNode.style;
        inlineStyle.fontVariant = inlineStyle.fontVariant ? '' : 'small-caps';
    }
    // We can't use page numbers as keys, because we might need to render the same page twice
    // for responsive layout. We also can't use index as a key, because React might reuse the
    // node for another page, and keep keyboard focus on it, which we don't want.
    renderLayout(layout, isDummy) {
        const { currentPage, pageUrl, disabled } = this.props;
        return layout.map((pageNumber, index) => {
            if (!pageNumber) {
                return (React.createElement("span", { key: index, className: classes.gap }, this.props.gapLabel));
            }
            if (pageNumber === currentPage) {
                return (React.createElement("div", { "aria-current": "page", key: `${pageNumber}-${index}-parent` },
                    React.createElement("span", { key: `${pageNumber}-${index}`, "data-hook": `${DataHooks.page}-${pageNumber} ${DataHooks.currentPage}`, className: classes.currentPage }, pageNumber)));
            }
            if (isDummy) {
                return (React.createElement("a", { key: `${pageNumber}-${index}`, className: st(classes.pageButton, { disabled }) }, pageNumber));
            }
            const defaultButtonProps = {
                key: `${pageNumber}-${index}`,
                'data-hook': `${DataHooks.page}-${pageNumber}`,
                'aria-label': `Page ${pageNumber}`,
            };
            return pageUrl && !disabled ? (React.createElement("a", { className: st(classes.pageButton, { disabled }), onClick: (e) => this.props.handlePageClick(e, pageNumber), href: pageUrl(pageNumber), ...defaultButtonProps }, pageNumber)) : (React.createElement("button", { className: st(classes.pageButton, { disabled }), disabled: disabled, onClick: !disabled
                    ? (event) => this.props.handlePageClick(event, pageNumber)
                    : null, ...defaultButtonProps }, pageNumber));
        });
    }
    isResponsive() {
        return (this.props.responsive &&
            this.props.totalPages > 0 &&
            this.props.maxPagesToShow > 1);
    }
    getLayout() {
        if (!this.isResponsive()) {
            return createStaticLayout(this.props);
        }
        if (this.state.responsiveLayout) {
            return this.state.responsiveLayout;
        }
        return createStaticLayout({
            totalPages: this.props.totalPages,
            currentPage: this.props.currentPage,
            showFirstPage: this.props.showFirstPage,
            showLastPage: this.props.showLastPage,
            // This is pretty arbitrary. 5 is the minimum space required to show the first, current, and last page.
            maxPagesToShow: 5,
        });
    }
    updateLayoutIfNeeded() {
        if (!this.isResponsive() || this.responsiveLayoutIsFresh) {
            return;
        }
        this.responsiveLayoutIsFresh = true;
        this.setState({
            responsiveLayout: createResponsiveLayout({
                container: this.rootNode.children[1],
                totalPages: this.props.totalPages,
                currentPage: this.props.currentPage,
                maxPagesToShow: this.props.maxPagesToShow,
                showFirstPage: this.props.showFirstPage,
                showLastPage: this.props.showLastPage,
            }),
        });
    }
}
//# sourceMappingURL=PageStrip.js.map